import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { User } from '@/models/user/user';
import { usersService } from '@/services/users';

@Component
export default class UserCreate extends Vue {
    user: User = new User();
    loading = false;
    invalidFields: string[] = [];
    roleOptions = [
        { value: 'ADMIN', text: 'Administrator' },
        { value: 'SIMPLE', text: 'Customer' }
    ];

    validate() {
        this.clearValidation();
        if (!this.user.username) this.invalidFields.push('username');
        if (!this.user.role) this.invalidFields.push('role');
        if (!this.user.password) this.invalidFields.push('password');
    }

    clearValidation() {
        if (this.invalidFields.length) {
            this.invalidFields.splice(0, this.invalidFields.length);
        }
    }

    getValidationState(fieldname: string) {
        return this.invalidFields.indexOf(fieldname) >= 0 ? false : null;
    }

    async save() {
        this.validate();
        if (this.invalidFields.length > 0) return;

        this.loading = true;
        try {
            await usersService.createUser(this.user);
            this.$router.push('/users');
        } catch (error) {
            this.$bvToast.toast('Failed to create user', {
                title: 'Error',
                variant: 'danger'
            });
        } finally {
            this.loading = false;
        }
    }

    cancel() {
        this.$router.push('/users');
    }
}
